'use client';
import { Disclosure, DisclosureButton, DisclosurePanel, Popover, PopoverButton, PopoverGroup, PopoverPanel, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import React from 'react';
import { avoidFocusOnClick } from '../../utils/avoidFocusOnClick';
export function DesktopMenu(param) {
    var children = param.children;
    return /*#__PURE__*/ React.createElement(PopoverGroup, {
        className: "hidden lg:flex lg:gap-x-12"
    }, children);
}
export function DesktopMenuDropDown(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ React.createElement(Popover, {
        className: "relative"
    }, function(param) {
        var open = param.open;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PopoverButton, {
            className: clsx('ml-8 flex items-center text-base font-medium hover:text-blue-600', open ? 'text-blue-600' : 'text-gray-900'),
            onClick: function() {
                return avoidFocusOnClick();
            }
        }, title, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            className: clsx('size-5 flex-none text-blue-600', open && 'rotate-180'),
            "aria-hidden": "true"
        })), /*#__PURE__*/ React.createElement(Transition, {
            as: React.Fragment,
            enter: "transition ease-out duration-200",
            enterFrom: "opacity-0 translate-y-1",
            enterTo: "opacity-100 translate-y-0",
            leave: "transition ease-in duration-150",
            leaveFrom: "opacity-100 translate-y-0",
            leaveTo: "opacity-0 translate-y-1"
        }, /*#__PURE__*/ React.createElement(PopoverPanel, {
            className: "absolute left-8 top-full z-10 mt-3 w-56 rounded bg-white shadow-md ring-1 ring-gray-100"
        }, children)));
    });
}
export function DesktopMenuDropdownDisclosure(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ React.createElement(Disclosure, {
        as: "div",
        className: ""
    }, function(param) {
        var open = param.open;
        return /*#__PURE__*/ React.createElement("div", {
            className: clsx('m-1.5 rounded', open && 'bg-gray-100')
        }, /*#__PURE__*/ React.createElement(DisclosureButton, {
            className: clsx('flex w-full items-center justify-between px-2 py-1 text-sm leading-5 hover:text-blue-600', open ? 'font-medium text-blue-600' : 'text-gray-500')
        }, title, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            className: clsx('size-5 flex-none text-blue-600', {
                'rotate-180': open
            }),
            "aria-hidden": "true"
        })), /*#__PURE__*/ React.createElement(DisclosurePanel, {
            className: ""
        }, children));
    });
}
